import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import AlternativeUnit from './AlternativeUnit'
import TTextDM from './TTextDM'
import TProductKeyDM from './TProductKeyDM'
import TArticleDM from './TArticleDM'

export default class TPromotionRangeDM extends Data {
	public static className = 'TPromotionRangeDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	SequenceNumber?: number
	Quantity?: number
	PromotionRID?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	QuantityMeasureUnitCalc?: string
	@Type(() => AlternativeUnit)
	MeasureUnitId?: AlternativeUnit
	@Type(() => TTextDM)
	MeasureUnitTypeId?: TTextDM
	@Type(() => TProductKeyDM)
	ProductGroupRID?: TProductKeyDM
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}